/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var LOAD_MORE = "load-more";
var LOADING = "loading";

export { LOADING, LOAD_MORE };
//# sourceMappingURL=const.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/list/const.js
// module id = null
// module chunks = 